/**
 * Owner: Masa Bayu
 * File: has-fixed-pages.ts
 * Date:Time: 2026-10-24 16:40
 * Description: D1 — satu predikat layout tetap untuk QXW; mod Studio (Halaman vs Tulis)
 *   dibaca dari sini oleh qxeditor dan qxwriter.
 */
/** Tip has fixed-layout membership when any page lists elements. */
export function qxwHasFixedPages(doc) {
    return doc.pages.some((page) => page.elementIds.length > 0);
}
//# sourceMappingURL=has-fixed-pages.js.map